var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4EAF94",
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7931A",
    d: "M23.6 14.9A12 12 0 1 1 .4 9.1a12 12 0 0 1 23.2 5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.3 10.3c.2-1.6-1-2.5-2.7-3l.6-2.2-1.3-.3-.6 2c-.3 0-.7 0-1-.2l.5-2-1.3-.4-.5 2.1c-.3 0-.6 0-.9-.2l-1.8-.4L8 7l1 .2c.4.2.5.5.5.8L9 10.6h.2-.2L8.1 14c-.1.2-.3.4-.7.3l-1-.2-.6 1.5 1.7.4.6.2h.4l-.6 2.3 1.4.3.5-2.2 1 .3-.5 2.2 1.3.3.6-2.2c2.2.4 4 .2 4.6-1.8.6-1.6 0-2.6-1.2-3.2.9-.2 1.5-.7 1.7-2Zm-3 4.2c-.4 1.5-2.7.9-3.8.6h-.3l.7-3 .4.1c1 .3 3.4.8 3 2.3ZM11.5 11c.9.2 2.8.7 3.2-.6.3-1.4-1.6-1.8-2.5-2l-.3-.1-.6 2.6h.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-3 14h29v7H-3z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.2 19.3H6v.2h-.3v.3h-.2v.2H3v-5h2.5v.2h.2v.3H6v.2h.2v1.1H6v.2h-.3v.3h-.2v.2h.2v.2H6v.3h.2v1.3Zm-.7-2.7v-.7h-.3v-.2H3.7V17H5v-.2h.2v-.2h.3Zm0 2.5v-1h-.3V18H5v-.3H3.7v1.6h1.5v-.2h.3ZM9.9 20H6.7v-5h3.2v.7H7.4V17h2v.7h-2v1.6H10v.7ZM13.6 17.3h-.2v.2H13v.2H13v.3H11v2h-.7v-5h2.5v.2h.2v.3h.3v.2h.2v1.6Zm-.7-.3v-1h-.3v-.3h-1.5v1.6h1.5V17h.3ZM17.3 20h-3.2v-1.8h.2V18h.3v-.3h.2v-.2h.3v-.2h1V17h.2v-.2h.3V16h-.3v-.2h-1.2v.2h-.3v.5h-.7v-.7h.2v-.2h.3v-.3h.2V15h1.8v.2h.2v.3h.3v.2h.2V17h-.2v.3h-.3v.2h-.2v.2h-.3v.3h-1v.2h-.2v.2h-.3v1h2.5v.6ZM21 19h-.2v.3h-.3v.2h-.2v.3H20v.2h-1.2v-.2h-.3v-.3h-.2v-.2H18v-.2h-.2v-3.2h.2v-.2h.3v-.2h.2v-.3h.3V15H20v.2h.3v.3h.2v.2h.3v.2h.2v3.2Zm-1-2.9v-.4h-1.2v.2h-.3v2.5h.3V18h.2v-.5h.3V17h.2v-.4h.3V16h.2Zm.3 3v-2.3H20v.5h-.2v.4h-.3v.5h-.2v.4H19v.5h-.2v.2H20v-.2h.3Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcb);
export default __webpack_public_path__ + "static/media/BTCB.02e8d15b0faa67a3d0ef9c47a6fe6ab6.svg";
export { ForwardRef as ReactComponent };